module.exports = {
          srcSet: __webpack_public_path__ + "193e33d06851f7cf16f11c95c067f6e0-192.png"+" 192w",
          images:[ {path: __webpack_public_path__ + "193e33d06851f7cf16f11c95c067f6e0-192.png",width: 192,height: 107}],
          src: __webpack_public_path__ + "193e33d06851f7cf16f11c95c067f6e0-192.png",
          toString:function(){return __webpack_public_path__ + "193e33d06851f7cf16f11c95c067f6e0-192.png"},
          
          width: 192,
          height: 107
        }